
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[urlKey]/cpd/[productSku]",
      function () {
        return require("private-next-pages/[urlKey]/cpd/[productSku].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[urlKey]/cpd/[productSku]"])
      });
    }
  